import React from 'react';
import { Link } from 'react-router-dom';
import styles from './estadisticas.module.css';

const EstadisticasLanding = () => {
  const modules = [
    {
      to: '/estadisticas/visitas',
      icon: '📊',
      iconBg: '#E8E8F8',
      title: 'Visitas a Propiedades',
      desc: 'Encuestas de satisfacción, funnel de conversión, rankings de propiedades y agentes, evolución temporal.'
    },
    {
      to: '/estadisticas/productividad',
      icon: '📈',
      iconBg: '#EAF8F0',
      title: 'Productividad de Agentes',
      desc: 'Propiedades cargadas, cerradas, tasas de cierre, operaciones por agente, comparativas.'
    },
    {
      to: '/estadisticas/reuniones',
      icon: '👤',
      iconBg: '#F5E6EC',
      title: 'Reuniones Individuales',
      desc: 'Score de performance, evolución mensual, ranking de agentes, tips IA, informes individuales.'
    }
  ];

  return (
    <div className={styles.landingContainer}>
      <h1 className={styles.landingTitle}>Estadísticas</h1>
      <p className={styles.landingSubtitle}>Panel de analítica ByRaíces — Selecciona un módulo para comenzar</p>
      <div className={styles.landingGrid}>
        {modules.map((m) => (
          <Link key={m.to} to={m.to} className={styles.landingCard}>
            <div className={styles.landingCardIcon} style={{ background: m.iconBg }}>
              {m.icon}
            </div>
            <span className={styles.landingCardTitle}>{m.title}</span>
            <span className={styles.landingCardDesc}>{m.desc}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default EstadisticasLanding;
